export default __webpack_public_path__ + "static/media/logo.525e9000.png";